'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = fontAdapt;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function fontAdapt(fontProps) {

    var style = {};
    if (fontProps === undefined) return style;
    style = _lodash2['default'].omit(fontProps, ['color', 'bold', 'italic', 'underline']);
    if (fontProps.color) style['fill'] = _lodash2['default'].isString(fontProps.color) ? fontProps.color : fontProps.color.color;
    if (fontProps.bold) style['fontWeight'] = 'bold';
    if (fontProps.italic) style['fontStyle'] = 'italic';
    if (fontProps.underline) style['borderBottom'] = '1px dashed #999';
    return style;
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-pathjs-chart/lib/fontAdapter.js
 ** module id = 83
 ** module chunks = 0
 **/